import styled from 'styled-components';

export default styled.div.attrs({
  className: 'b-shadow-box'
})`
  border-radius: ${({ theme }) => theme.indent.s};
  background-color: ${({ theme }) => theme.color.bgSecondary};
  box-shadow: 0 3px 4px 0 ${({ theme }) => theme.color.rgbaBlack(0.11)};
`;
